import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, FieldFeedbackLabel } from "../../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  AddressMolecule,
  SelectInput,
  RadioButtonGroup
} from "../../../../../../component/index.jsx"
import { PopUpMapSelector } from "../../../../../../component/molecule/PopUpMapSelector/index.jsx"
import { useFormikContext } from "formik"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { loadUserLogin } from "../../../../../../config/index.jsx"
import {
  getBasecampTypeList,
  getListRegionalAll,
  getListSubRegionalByRole,
  getWarehouseAvailableListByType
} from "../../../../../../redux/actions/MasterDataAction.jsx"
import { MASTER } from "../../../../../../constants/InitTypeConstants.js"
import { Skeleton } from "@material-ui/lab"
import { BaseMapSelector } from "../../../../../../component/atoms/MapSelector/BaseMapSelector.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { useParams } from "react-router-dom"
import { WAREHOUSE_TYPE_ENUM } from "../../../../../../constants/StringConstant.js"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"
import { Marker } from "@react-google-maps/api"

export const DataBase = ({ isReadOnly }) => {
  const { values: formValues, setFieldValue, setFieldTouched, setFieldError, errors, touched } = useFormikContext()
  const { t } = useTranslation()
  const { id } = useParams()
  const dispatch = useDispatch()
  const { MasterData, General } = useSelector((state) => state)
  const user = loadUserLogin()
  const [showMapSelector, setShowMapSelector] = useState(false)
  const [subRegionalList, setSubRegionalList] = useState([])
  const [regionalList, setRegionalList] = useState([])

  useEffect(() => {
    dispatch(getBasecampTypeList())
    dispatch(getListRegionalAll())
    dispatch(getWarehouseAvailableListByType(WAREHOUSE_TYPE_ENUM.BASE))
  }, [])

  useEffect(() => {
    if (MasterData.listRegionalAll) {
      setRegionalList(
        MasterData.listRegionalAll.map((value) => ({
          label: value.name + " (" + value.code + ")",
          value: value.id
        }))
      )

      // Set user's regional if they have one
      if (!id) {
        if (user?.regional_id) {
          setFieldValue("regionalId", user.regional_id)
        }
      }
    }
  }, [MasterData.listRegionalAll])

  useEffect(() => {
    if ((formValues?.regionalId && formValues.regionalId.trim() !== "")) {
      dispatch(getListSubRegionalByRole(formValues.regionalId, user?.role))
    }
  }, [formValues?.regionalId])

  useEffect(() => {
    if (MasterData.listSubRegionalByRole) {
      setSubRegionalList(
        MasterData.listSubRegionalByRole.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.listSubRegionalByRole])

  const onChangeRegional = (value) => {
    setFieldValue("regionalId", value)
    setFieldValue("sub_regional_id", "")
    // Reset address fields when regional changes
    setFieldValue("baseProvince", "")
    setFieldValue("baseRegency", "")
    setFieldValue("baseDistrict", "")
    setFieldValue("baseSubDistrict", "")
    setFieldValue("basePostalCode", "")
    setFieldValue("baseAddress", "")
  }

  const handleAssignWarehouseChange = (value) => {
    setFieldValue("useAvaliableWarehouse", String(value))
    if (value === "false") {
      setFieldValue("warehouseId", "")
      setFieldError("warehouseId", undefined)
    } else if (value === "true") {
      setFieldError("warehouseId", undefined)
      dispatch(getWarehouseAvailableListByType(WAREHOUSE_TYPE_ENUM.BASE))
    }
  }

  const handleMapSave = ({ lat, lng, address }) => {
    setFieldValue("latitude", lat)
    setFieldValue("longitude", lng)
    setFieldTouched("latitude", true)
    setFieldTouched("longitude", true)
    setTimeout(() => {
      setFieldError("latitude", undefined)
      setFieldError("longitude", undefined)
    }, 0)
    if (address) {
      setFieldValue("baseAddress", address)
    }
    setShowMapSelector(false)
  }


  return (
    <>
      <PopUpMapSelector
        show={showMapSelector}
        onCancel={() => setShowMapSelector(false)}
        onSave={handleMapSave}
        initialLat={formValues?.latitude}
        initialLng={formValues?.longitude}
        hasLocationAlreadySaved={!!(formValues?.latitude && formValues?.longitude)}
      />
      <Card className="card-custom card-shadowless">
        <CardBody>
          {/* Detail Base Section */}
          <RowModule>
            <CardHeader className={"border-0"} title={t("sub_header_detail_base").toUpperCase()} />
          </RowModule>
          <RowModule>
            <div className={"mx-8"}>
              {!(General?.loading) ? (
                <SelectInput
                  name="regionalId"
                  required
                  onChange={onChangeRegional}
                  editable={!(id ? true : (user?.regional_id !== null))}
                  label={t("label_regional")}
                  placeholder={t("placeholder_choose_one")}
                  value={formValues["regionalId"]}
                  options={regionalList}
                />
              ) : <Skeleton variant={"rect"} />}
            </div>
          </RowModule>
          <RowModule>
            <div className={"mx-8"}>
              {!(General?.loading) ? (
                <SelectInput
                  name="sub_regional_id"
                  required
                  onChange={(value) => {
                    setFieldValue("sub_regional_id", value)
                  }}
                  editable={!id}
                  label={t("label_sub_regional")}
                  placeholder={t("placeholder_choose_one")}
                  value={formValues["sub_regional_id"]}
                  options={subRegionalList}
                />
              ) : <Skeleton variant={"rect"} />}
            </div>
          </RowModule>
          <RowModule>
            <div className={"mx-8"}>
              {!(General?.loading && General?.actionInitType === MASTER.GET_BASE_TYPE_LIST) ? <SelectInput
                required
                editable={true}
                label={t("label_base_type")}
                name="type"
                value={formValues?.type}
                placeholder={t("placeholder_select_base_type")}
                options={MasterData?.listBaseType?.map((item) => ({ value: item?.type_enum, label: item?.type_string }))}
              /> : <Skeleton variant={"rect"} />}
            </div>
          </RowModule>
        </CardBody>
      </Card>

      {/* Alamat Base Section */}
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <CardHeader className={"border-0"} title={t("label_base_address").toUpperCase()} />
          </RowModule>
          {!General?.loading ? (
            <>
              <div className={"mx-8 position-relative"} onClick={() => {
                setShowMapSelector(true)
              }}>
                <div className={"position-absolute d-flex justify-content-center align-items-center zindex-3"}
                  style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                  {(formValues?.latitude !== 0 || formValues?.longitude !== 0) ? null : <SVG src={toAbsoluteUrl(ICON_CONSTANTS.QUICK_ACTION_ADD)} />}
                </div>
                <div className={(touched.latitude || touched.longitude) && (errors.latitude || errors.longitude) ? "border border-danger rounded-lg" : ""}>
                  <BaseMapSelector
                    className={"rounded-lg mb-2"}
                    id={"preview-base-map-selector"}
                    latitude={formValues?.latitude}
                    longitude={formValues?.longitude}
                    isSelector={false}
                    editable={false}
                    customMarkers={() => (
                      formValues?.latitude !== 0 && formValues?.longitude !== 0 ? <Marker
                        position={{ lat: formValues?.latitude, lng: formValues?.longitude }}
                        icon={toAbsoluteUrl(ICON_CONSTANTS.MARKER_BASECAMP)}
                        draggable={false}
                      /> : null
                    )}
                    customContainerStyle={{
                      height: "250px"
                    }}
                    options={{
                      zoomControl: false
                    }}
                    zoom={15}
                  />
                </div>
                <FieldFeedbackLabel
                  error={errors?.latitude || errors?.longitude}
                  touched={touched.latitude && touched.longitude}
                  label={t("label_base_location_on_map")}
                />
              </div>
            </>
          ) : <Skeleton variant={"rect"} className={"mx-8"} height={"250px"} />}
          <AddressMolecule
            removeTitleSeparator={true}
            required
            byRegional={!!user?.regional_id}
            regionalId={user?.regional_id}
            isChangeRegional={!!user?.regional_id}
            editable={true}
            name={"base"}
            isReadOnly={false}
            onProvinceChange={(value) => setFieldValue("baseProvince", value)}
            onRegencyChange={(value) => setFieldValue("baseRegency", value)}
            onDistrictChange={(value) => setFieldValue("baseDistrict", value)}
            onSubDistrictChange={(value) => setFieldValue("baseSubDistrict", value)}
            onPostalCodeChange={(value) => setFieldValue("basePostalCode", value)}
            onAddressChange={(value) => setFieldValue("baseAddress", value)}
          />
        </CardBody>
      </Card>

      {/* Assign Base to Warehouse Section */}
      <Card className="card-custom card-shadowless">
        <CardBody>
          <RowModule>
            <CardHeader className={"border-0"} title={t("label_assign_base_to_odoo_warehouse").toUpperCase()} />
          </RowModule>
          <div className={"mx-8"}>
            <RowModule>
              <RadioButtonGroup
                required
                editable={!id}
                name="useAvaliableWarehouse"
                onClick={handleAssignWarehouseChange}
                value={"true"}
                checked={formValues?.useAvaliableWarehouse === "true"}
                withoutFeedback={true}
                label={t("label_existing_odoo_warehouse")}
                row
              />
              <RadioButtonGroup
                required
                editable={!id}
                name="useAvaliableWarehouse"
                onClick={handleAssignWarehouseChange}
                value={"false"}
                checked={formValues?.useAvaliableWarehouse === "false"}
                withoutFeedback={true}
                label={t("label_create_new_odoo_warehouse")}
                row
              />
            </RowModule>
            <FieldFeedbackLabel
              error={errors?.useAvaliableWarehouse}
              touched={touched.useAvaliableWarehouse}
              label={t("label_assign_base_to_odoo_warehouse")}
            />
          </div>
          {formValues?.useAvaliableWarehouse === "true" && (
            !id ? (General?.loading && General?.actionInitType === MASTER.GET_WAREHOUSE_AVAILABLE_LIST_BY_TYPE) ?
              <Skeleton variant={"rect"} height={48} />
              :
              (
                <div className={"mx-8"}>
                  <SelectInput
                    required
                    editable={!isReadOnly && !(id && MasterData?.baseInitDetail?.warehouse_id)}
                    label={t("label_select_warehouse")}
                    name="warehouseId"
                    placeholder={t("placeholder_select_odoo_warehouse")}
                    options={MasterData?.listWarehouseAvailable.map((item) => ({ value: item.id, label: item.name }))}
                    value={formValues?.warehouseId}
                  />
                </div>
              ) : <span className="mx-8">{t("label_warehouse_code")} : <span className="font-weight-bolder">{stringFormatting(MasterData?.baseInitDetail?.warehouse_code)}</span></span>
          )}
        </CardBody>
      </Card>
    </>
  )
}

